<template>
  <div class="col-12">
    <b-tabs content-class="mt-3" class="bg-white border" justified>
      <b-tab
        v-for="(task, i) in tnames"
        :key="i"
        :title="getFullTaskName(task)"
      >
        <v-card-title>
          <!--        TEST-->
          <!--        <v-spacer></v-spacer>-->
          <!--        <v-text-field-->
          <!--          v-model="search[task]"-->
          <!--          append-icon="mdi-magnify"-->
          <!--          label="Search"-->
          <!--          single-line-->
          <!--          hide-details-->
          <!--        ></v-text-field>-->

          <v-text-field
            v-model="search[task]"
            append-icon="mdi-magnify"
            label="Search"
            style="margin-top: -17px"
            single-line
            dense
            hide-details
          ></v-text-field>

          <v-select
            style="max-width: 200px"
            v-model="supervisionFilter[task]"
            :items="['supervised', 'weakly-supervised', 'unsupervised']"
            @change="filterCleanTasks(task)"
            label="Supervision"
            class="custom-multi-chip"
            dense
            multiple
          >
            <template v-slot:selection="{ item, index }">
              <v-chip x-small v-if="index === 0">
                <span>{{ item }}</span>
              </v-chip>
              <span v-if="index === 1" class="grey--text caption">
                (+{{ supervisionFilter[task].length - 1 }} others)
              </span>
            </template>
          </v-select>

          <v-select
            style="max-width: 100px"
            v-model="codeFilter[task]"
            no-data-text="test"
            :items="['Show all', 'Only with Code']"
            @change="filterCleanTasks(task)"
            label="Code"
            class="code-input"
            dense
          >
          </v-select>
        </v-card-title>
        <v-data-table
          dense
          :headers="getHeaders()"
          :items="cleanTasks[task]"
          :search="search[task]"
          :sort-by.sync="sortby"
          :sort-desc.sync="desc"
        >
          <!--          <template v-slot:footer>-->
          <!--            <div-->
          <!--              style="position: absolute; margin-left: 15px; margin-top:20px;"-->
          <!--            >-->
          <!--              <v-select-->
          <!--                style="max-width: 350px"-->
          <!--                v-model="supervisionFilter[task]"-->
          <!--                :items="['supervised', 'weakly-supervised', 'unsupervised']"-->
          <!--                @change="filterCleanTasks(task)"-->
          <!--                label="Supervision"-->
          <!--                class="custom-multi-chip"-->
          <!--                dense-->
          <!--                multiple-->
          <!--              >-->
          <!--                <template v-slot:selection="{ item, index }">-->
          <!--                  <v-chip x-small v-if="index === 0">-->
          <!--                    <span>{{ item }}</span>-->
          <!--                  </v-chip>-->
          <!--                  <span v-if="index === 1" class="grey&#45;&#45;text caption">-->
          <!--                    (+{{ supervisionFilter[task].length - 1 }} others)-->
          <!--                  </span>-->
          <!--                </template>-->
          <!--              </v-select>-->
          <!--            </div>-->
          <!--          </template>-->

          <template v-slot:item.controls="props">
            <router-link
              style="padding: 3px 12px 3px 12px; margin: 2px 0px 2px 0px;"
              :to="'/submissions/' + props.item._id"
              class="btn btn-secondary"
            >
              <i class="fas fa-file-alt"></i>
            </router-link>
          </template>

          <template v-slot:item.code="props" v-if="hasCode">
            <div v-if="props.item.code">
              <a :href="getHrefLink(props.item.code)">
                yes
              </a>
            </div>
            <div v-else>
              no
            </div>
          </template>
        </v-data-table>
      </b-tab>
    </b-tabs>
  </div>
</template>

<style lang="scss">
.v-expansion-panel-content__wrap {
  padding: 0 !important;
}

.custom-multi-chip {
  padding-top: 4px;
  margin: 5px;
  .label.v-label {
    font-weight: bold !important;
  }
}

.code-input {
  margin: 5px;
  .v-select__selections {
    font-size: 12px;
  }
}

.v-label {
  font-size: 15px !important;
}

.v-data-table-header {
  background: #00968830;
}
</style>

<script>
import { getFullTaskName, getSupervisionLabel } from "@/helpers/utils";
import { getHrefLink } from "@/helpers/utils";

import moment from "moment";

export default {
  components: {},
  props: {
    tasks: Object,

    isSemantic: {
      type: Boolean,
      default: false
    },
    isUncertain: {
      type: Boolean,
      default: false
    },
    isDetection: {
      type: Boolean,
      default: false
    },
    isPanoptic: {
      type: Boolean,
      default: false
    },
    hasCode: {
      type: Boolean,
      default: false
    },
    additionalHeaders: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    tasks: function(newVal, oldVal) {
      this._cleanTasks = newVal;
      this.cleanTasks = {};
      for (const task in this._cleanTasks) {
        this._cleanTasks[task] = this.mapEntry(this._cleanTasks[task]);
        this.cleanTasks[task] = Array.from(this._cleanTasks[task]);
      }
    }
  },
  data() {
    let sortingCriterion;
    if (this.isSemantic)
      sortingCriterion = "results.IoU.IoU";
    if (this.isUncertain)
      sortingCriterion = "results.Average_UIoU.Average_UIoU";
    if (this.isDetection)
      sortingCriterion = "results.AP.AP";
    if (this.isPanoptic)
      sortingCriterion = "results.PQ.PQ";

    // Table header names
    const tnames = ["all", "fog", "night", "rain", "snow"];
    if (!this.isUncertain) {
      tnames.push("normal");
      tnames.push("allAdverseAndNormal");
    }
    return {
      sortby: sortingCriterion,
      desc: true,
      tnames:tnames,
      panel: [0],
      search: {},
      cleanTasks: {},
      supervisionFilter: {
        all: ["supervised", "weakly-supervised", "unsupervised"],
        rain: ["supervised", "weakly-supervised", "unsupervised"],
        snow: ["supervised", "weakly-supervised", "unsupervised"],
        fog: ["supervised", "weakly-supervised", "unsupervised"],
        night: ["supervised", "weakly-supervised", "unsupervised"],
        normal: ["supervised", "weakly-supervised", "unsupervised"],
        allAdverseAndNormal: ["supervised", "weakly-supervised", "unsupervised"]
      },
      codeFilter: {
        all: ["Show all"],
        rain: ["Show all"],
        snow: ["Show all"],
        fog: ["Show all"],
        night: ["Show all"],
        normal: ["Show all"],
        allAdverseAndNormal: ["Show all"]
      }
    };
  },
  methods: {
    getHrefLink: function(link) {
      return getHrefLink(link);
    },
    mapEntry: function(entries) {
      if (!entries) return entries;

      return entries.map(entry => {
        entry.supervision = getSupervisionLabel(entry);
        entry.createdAt = moment(entry.created_at).format("YYYY/MM/DD HH:mm");
        return entry;
      });
    },
    getFullTaskName,
    filterCleanTasks: function(task) {
      this.cleanTasks[task] = this._cleanTasks[task].filter(
        entry =>
          this.supervisionFilter[task].indexOf(entry.supervision) !== -1 &&
          (entry.code || this.codeFilter[task] == "Show all")
      );
      this.cleanTasks = Object.assign({}, this.cleanTasks);
    },
    getHeaders: function() {
      const headers = [
        {
          text: "Name",
          align: "start",
          filterable: true,
          value: "method_name"
        }
      ];

      if (this.isSemantic)
        headers.push({
          text: "IoU",
          align: "start",
          filterable: true,
          value: "results.IoU.IoU"
        });

      if (this.isUncertain) {
        headers.push({
          text: "Avg UIoU",
          align: "start",
          filterable: true,
          value: "results.Average_UIoU.Average_UIoU"
        });
        headers.push({
          text: "IoU",
          align: "start",
          filterable: true,
          value: "results.IoU.IoU"
        });
      }

      if (this.isDetection) {
        headers.push({
          text: "AP",
          align: "start",
          filterable: true,
          value: "results.AP.AP"
        });
      }

      if (this.isPanoptic) {
        headers.push({
          text: "PQ",
          align: "start",
          filterable: true,
          value: "results.PQ.PQ"
        });
        headers.push({
          text: "PQ things",
          align: "start",
          filterable: true,
          value: "results.PQ.PQ_things"
        });
        headers.push({
          text: "PQ stuff",
          align: "start",
          filterable: true,
          value: "results.PQ.PQ_stuff"
        });
      }

      headers.push({
        text: "Supervision",
        value: "supervision",
        sortable: true,
        align: "end"
      });

      for (const header of this.additionalHeaders) {
        headers.push(header);
      }
      headers.push({
        text: "Date",
        value: "createdAt",
        sortable: true,
        align: "end"
      });
      headers.push({
        text: "",
        value: "controls",
        sortable: false,
        align: "end"
      });
      return headers;
    }
  }
};
</script>
